import styled from 'styled-components';

import DefWarning from 'components/Warning';

export const Warning = styled(DefWarning)`
  width: auto;
  margin: 0 0 10px 240px;
`;
